import { useMemo } from 'react';

// Deduplicates IDs across N collections — used by wrappers that surface a
// "visible via QR" toggle so the VisibleViaQrColumnConfig knows which rows
// have been displayed at least once across the All and Selected tabs.
export default function useVisibleLinkableIds<
  T extends { id: string | number },
>(...sources: T[][]): string[] {
  return useMemo(() => {
    const ids = new Set<string>();
    sources.forEach((source) => {
      source.forEach((item) => ids.add(String(item.id)));
    });
    return Array.from(ids);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, sources);
}
